<svg [climbIcon]="icons.cross"></svg>
